import React, { useEffect } from 'react';

const TitleUpdater: React.FC = () => {
    useEffect(() => {
        // Get project ID from environment variables
        const envProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;

        // Set title based on environment variable
        if (envProjectId === 'fg2p-test') {
            // console.log('Setting title to FG2P - TEST');
            document.title = 'FG2P - TEST';
        } else if (envProjectId === 'fg2p-prod') {
            // console.log('Setting title to FG2P');
            document.title = 'FG2P';
        } else {
            // console.log('Unknown environment, setting title to FG2P');
            document.title = 'FG2P';
        }

        // console.log('- New document.title:', document.title);
    }, []);

    return null; // This component doesn't render anything
};

export default TitleUpdater; 